var map = {
	"./renders/CopyButton/index.js": 5656,
	"./renders/DefaultAssignmentPlans/index.js": 5893,
	"./renders/InheritableAssignmentPlan/index.js": 5657,
	"./renders/PeerNomLockReset/index.js": 5658,
	"./renders/PercentComplete/index.js": 5659,
	"./renders/Rescore/index.js": 5894,
	"./renders/StudentLauncher/index.js": 5660,
	"./renders/UploadImage/index.js": 1105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2062;